module.exports = __webpack_public_path__ + "img/06.19e16825.png";